require("dotenv").config();
import { createApp } from "vue";
import App from "./App.vue";
import pinia from "./store/pinia";
import router from "./router";
import PrimeVue from "primevue/config";
import i18n from "./config/i18n";
import { GOOGLE_MAPS_LOAD } from "./config/googleMaps";

import "primevue/resources/themes/tailwind-light/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./assets/styles/layout.scss";
import "./assets/flags/flags.css";

import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Carousel from 'primevue/carousel';
import Checkbox from "primevue/checkbox";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import DataView from "primevue/dataview";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import Editor from "primevue/editor";
import Fieldset from "primevue/fieldset";
import FileUpload from "primevue/fileupload";
import HighchartsVue from "highcharts-vue";
import Image from "primevue/image";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Menu from "primevue/menu";
import MultiSelect from "primevue/multiselect";
import Paginator from "primevue/paginator";
import PanelMenu from "primevue/panelmenu";
import RadioButton from "primevue/radiobutton";
import Ripple from "primevue/ripple";
import Row from "primevue/row";
import ScrollPanel from "primevue/scrollpanel";
import SelectButton from "primevue/selectbutton";
import Sidebar from "primevue/sidebar";
import Slider from "primevue/slider";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import TabMenu from "primevue/tabmenu";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import TieredMenu from "primevue/tieredmenu";
import Timeline from "primevue/timeline";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import TreeTable from "primevue/treetable";
import VueGoogleMaps from "@fawmi/vue-google-maps";

const app = createApp(App);

app.use(pinia).use(PrimeVue);

// PrimeVue 3 Calendar firstDayOfWeek default value is 0 (Sunday), we need to set it to 1 (Monday).
const primeVue = app.config.globalProperties.$primevue;
if (primeVue?.config?.locale) {
    primeVue.config.locale.firstDayOfWeek = 1;
}

app.use(router)
    .use(i18n)
    .use(HighchartsVue)
    .use(ConfirmationService)
    .use(ToastService)
    .use(VueGoogleMaps, {
        load: GOOGLE_MAPS_LOAD,
    })
    .component("AutoComplete", AutoComplete)
    .component("Button", Button)
    .component("Calendar", Calendar)
    .component("Card", Card)
    .component("Carousel", Carousel)
    .component("Checkbox", Checkbox)
    .component("Column", Column)
    .component("ColumnGroup", ColumnGroup)
    .component("ConfirmDialog", ConfirmDialog)
    .component("DataTable", DataTable)
    .component("DataView", DataView)
    .component("Dialog", Dialog)
    .component("Dropdown", Dropdown)
    .component("Editor", Editor)
    .component("Fieldset", Fieldset)
    .component("FileUpload", FileUpload)
    .component("Image", Image)
    .component("InputNumber", InputNumber)
    .component("InputSwitch", InputSwitch)
    .component("InputText", InputText)
    .component("Menu", Menu)
    .component("MultiSelect", MultiSelect)
    .component("Paginator", Paginator)
    .component("PanelMenu", PanelMenu)
    .component("RadioButton", RadioButton)
    .component("Row", Row)
    .component("ScrollPanel", ScrollPanel)
    .component("SelectButton", SelectButton)
    .component("Sidebar", Sidebar)
    .component("Slider", Slider)
    .component("Splitter", Splitter)
    .component("SplitterPanel", SplitterPanel)
    .component("TabMenu", TabMenu)
    .component("TabPanel", TabPanel)
    .component("TabView", TabView)
    .component("Tag", Tag)
    .component("Textarea", Textarea)
    .component("TieredMenu", TieredMenu)
    .component("Timeline", Timeline)
    .component("Toast", Toast)
    .component("TreeTable", TreeTable)
    .directive("ripple", Ripple)
    .directive("tooltip", Tooltip)
    .mount("#app");
